import allowResponseForSmimeItem from '../utils/allowResponseForSmimeItem';
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { ActionSource } from 'owa-analytics-actions';
import { ClientItemId } from 'owa-client-ids';
import loc, { format } from 'owa-localize';
import { irm_actionNotAllowedOnThisItem } from 'owa-locstrings/lib/strings/irm_actionnotallowedonthisitem.locstring.json';
import { itemHeaderReply } from 'owa-locstrings/lib/strings/itemheaderreply.locstring.json';
import { itemHeaderReplyAll } from 'owa-locstrings/lib/strings/itemheaderreplyall.locstring.json';
import { lazyReplyToMessage } from 'owa-mail-compose-actions';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { InstrumentationContext, mailStore } from 'owa-mail-store';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import Item from 'owa-service/lib/contract/Item';
import isSMIMEItem from 'owa-smime/lib/utils/isSMIMEItem';
import { action } from 'satcheljs/lib/legacy';

export default action('replyToItem')(async function replyToItem(
    itemId: ClientItemId,
    isReplyAll: boolean,
    instrumentationContexts: InstrumentationContext[],
    actionSource: ActionSource,
    suppressServerMarkReadOnReplyOrForward: boolean
) {
    const restrictionToConfirm = <IRMRestrictions>{
        ReplyAllAllowed: isReplyAll,
        ReplyAllowed: !isReplyAll,
    };
    const itemActionString = isReplyAll ? loc(itemHeaderReplyAll) : loc(itemHeaderReply);
    const item: Item = mailStore.items.get(itemId.Id);
    const isResponseAllowedForSmimeItem =
        !isSMIMEItem(item) || (await allowResponseForSmimeItem(itemId.Id, itemActionString));

    if (
        confirmItemActionAllowed(
            itemId.Id,
            restrictionToConfirm,
            format(loc(irm_actionNotAllowedOnThisItem), itemActionString)
        ) &&
        isResponseAllowedForSmimeItem
    ) {
        lazyReplyToMessage.importAndExecute({
            referenceItemId: itemId,
            isReplyAll: isReplyAll,
            useFullCompose: true,
            actionSource: actionSource,
            instrumentationContexts: instrumentationContexts,
            suppressServerMarkReadOnReplyOrForward: suppressServerMarkReadOnReplyOrForward,
        });

        mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
    }
});
